import * as React from "react";
function SvgIcLogin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.719 5.297v.75h6.73v12.018h-6.73v.75h7.48V5.297h-7.48z"
        fill="currentColor"
      />
      <path
        d="M8.902 5l-.649.375 3.633 6.294H4v.75h7.886l-3.633 6.294.649.375 4.067-7.044L8.902 5z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcLogin;
